import { PluginDocumentSettingPanel } from '@wordpress/editor';
import { useSelect, useDispatch } from '@wordpress/data';
import { SelectControl, Spinner,     __experimentalGrid as Grid, __experimentalText as Text} from '@wordpress/components';
import { useEffect, useState } from '@wordpress/element'

export default function CollectionMetaData(){
    const META_KEY = 'report_collection_id';
	const [metaDataCollection, setMetaDataCollection] = useState([]);
    const { editPost } = useDispatch('core/editor');
    const meta = useSelect((select) =>
        select('core/editor').getEditedPostAttribute('meta')? select('core/editor').getEditedPostAttribute('meta')['report_collection_id']: 0
    )
	const [isLoading, setIsLoading] = useState(false);

    if (meta != undefined){
        const { [META_KEY]: customMeta } = meta

		useEffect(() => {
			if (meta) {
				populateTags(meta)
			}
		}, [meta]);
		
    }

	const populateTags = (newValue) => {
		setIsLoading(true)
		fetch(`${wpApiSettings.root}tainacan/v2/collection/${newValue}/metadata`)
		.then((response) => response.json())
		.then((data) => {
			let filterMetaData = []

			data.forEach(element => {
				if (element) {
					filterMetaData.push({
						meta: element.name,
						slug: element.slug.toUpperCase()
					})
				}
			})
			setIsLoading(false);	
			setMetaDataCollection(filterMetaData)
		})
		.catch(() => setIsLoading(false));
	}

    const onCustomMetaChange = (newValue) => {
        if (newValue == undefined) {
            return
        }

        editPost({
            meta: { meta, [META_KEY]: newValue },
        })

		if ((newValue < 1) || (newValue == '0') || (newValue == 0)){
			setMetaDataCollection([])
			return
		}

		populateTags(newValue)
    };

	const { collections } = useSelect( ( select ) => {
		const { getEntityRecords } = select( 'core' );
	
		return {
			collections: getEntityRecords( 'postType', 'tainacan-collection', {status: 'publish'} ),
		}
	} )

	let options = [];
	if( collections ) {
		options.push( { value: 0, label: 'Selecione a coleção' } )
		collections.forEach( ( collectionItem ) => {
			options.push( { value : collectionItem.id, label : collectionItem.title.rendered } )
		})
	} else {
		options.push( { value: 0, label: 'Carregando...' } )
	}

    return (
        <PluginDocumentSettingPanel
            name="collection-meta-data-settings"
            title="Configurações"
            initialOpen="true"
            icon="dashicon-name"
        >
            <SelectControl
                label="Coleção"
                value={ meta || 0 }
                options={ options}
                onChange={ ( value ) => onCustomMetaChange(value) }
                __nextHasNoMarginBottom
            />
			<>
			</>
            {isLoading ? (
                <Spinner />
            ) : (
                <>
			<Grid columns={ 2 }>
				<Text>META</Text>
				<Text>TAG</Text>
				<Text>Dia</Text>
				<Text>__DIA__</Text>
				<Text>Mês</Text>
				<Text>__MES__</Text>
				<Text>Ano</Text>
				<Text>__ANO__</Text>
				<Text>URL</Text>
				<Text>__URL__</Text>				
				{metaDataCollection.map((value) => (
					<>
						<Text>{value.meta}</Text>
						<Text>__{value.slug}__</Text>
					</>
				))}

			</Grid>
			</>
			)}
        </PluginDocumentSettingPanel>
    );
}
